/*eslint-disable*/
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { API, rootAPI } from '../../config/api';
import { addMessage } from '../../redux/messages/actionCreator';

const ProductCard = ({ product, senderId, appId }) => {
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);
  const originalPrice = Number.parseFloat(product.price) * 1.3;
  const discountPercent = Math.round(((originalPrice - Number.parseFloat(product.price)) / originalPrice) * 100);

  const isProductObject = typeof product === 'object' && product !== null && product.product_name;

  let finalSrc = '../../static/img/noImage.png';

  if (isProductObject) {
    finalSrc =
      product.source === 'mongodb' ? `${rootAPI}/uploads/images/products/${product.image_url}` : product.image_url;
  } else if (typeof product === 'string') {
    const isExternalOrBlob = product.startsWith('http') || product.startsWith('blob:');
    finalSrc = isExternalOrBlob ? product : `${rootAPI}/uploads/images/${product}`;
  }

  const handleBuyProduct = async (value) => {
    const textMessage = `Hi, I am interested in purchasing "${value?.product_name}" price: "${value.price}", productId: "${value.product_id}". place order`;

    const cleanProductName = value.product_name.replace(/\[\[ID:.*?\]\]/g, '').trim();

    const customerMessage = {
      senderId,
      sender: 'customer',
      text: `I am interested in purchasing "${cleanProductName}" "${value.price}".`,
      timestamp: new Date().toISOString(),
    };

    dispatch(addMessage(customerMessage));

    try {
      await axios.post(`${API.generate_conversation}/${appId}`, {
        textMessage: textMessage,
        senderId,
      });
    } catch (error) {
      console.error(error);
      message.error('Failed to process order request.');
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'pointer',
        width: '220px',
        minWidth: '220px',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.1)';
      }}
    >
      {/* Image Container with Discount Badge */}
      <div style={{ position: 'relative', backgroundColor: '#f5f5f5', padding: '12px', flex: '0 0 auto' }}>
        {/* {discountPercent > 0 && (
          <div
            style={{
              position: 'absolute',
              top: '6px',
              left: '6px',
              backgroundColor: '#000',
              color: '#fff',
              padding: '2px 6px',
              borderRadius: '3px',
              fontSize: '9px',
              fontWeight: '600',
              zIndex: 1,
            }}
          >
            {discountPercent}% OFF
          </div>
        )} */}
        <img
          src={finalSrc}
          alt={product?.product_name}
          style={{
            width: '100%',
            height: '80px',
            objectFit: 'contain',
            display: imageLoaded ? 'block' : 'none',
          }}
          onLoad={() => setImageLoaded(true)}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '../../static/img/noImage.png';
            setImageLoaded(false);
          }}
        />
        {!imageLoaded && (
          <div
            style={{
              width: '100%',
              height: '80px',
              backgroundColor: '#e5e5e5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999',
              fontSize: '10px',
            }}
          >
            Loading...
          </div>
        )}
      </div>

      {/* Product Details */}
      {isProductObject && (
        <div style={{ padding: '8px', flex: '1', display: 'flex', flexDirection: 'column' }}>
          {/* Product Name */}
          <h4
            style={{
              margin: '0 0 6px 0',
              fontSize: '11px',
              fontWeight: '500',
              color: '#333',
              lineHeight: '1.2',
              height: '22px',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {product.product_name}
          </h4>

          {/* Price */}
          <div style={{ marginBottom: '6px' }}>
            <span
              style={{
                fontSize: '14px',
                fontWeight: '700',
                color: '#000',
              }}
            >
              ৳{product.price}
            </span>
            {/* {discountPercent > 0 && (
            <span
              style={{
                fontSize: '10px',
                color: '#999',
                textDecoration: 'line-through',
                marginLeft: '4px',
              }}
            >
              ${originalPrice.toFixed(0)}
            </span>
          )} */}
          </div>

          {/* Rating */}
          {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <div style={{ display: 'flex', gap: '1px', marginRight: '4px' }}>
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                style={{
                  color: star <= 4 ? '#ffc107' : '#e0e0e0',
                  fontSize: '10px',
                }}
              >
                ★
              </span>
            ))}
          </div>
          <span style={{ fontSize: '9px', color: '#666' }}>4.0</span>
        </div> */}

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '4px', marginTop: 'auto' }}>
            <button
              style={{
                width: '100%',
                //   margin: '0 auto',
                backgroundColor: '#1a365d',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 8px',
                fontSize: '10px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                transition: 'background-color 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#2c5282';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#1a365d';
              }}
              onClick={() => handleBuyProduct(product)}
            >
              <FeatherIcon icon="shopping-bag" size={12} />
              Buy Now
            </button>

            <button
              style={{
                width: '100%',
                //   margin: '0 auto',
                backgroundColor: 'transparent',
                color: '#1a365d',
                border: '1px solid #1a365d',
                borderRadius: '4px',
                padding: '6px 8px',
                fontSize: '10px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f7fafc';
                e.currentTarget.style.borderColor = '#2c5282';
                e.currentTarget.style.color = '#2c5282';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = '#1a365d';
                e.currentTarget.style.color = '#1a365d';
              }}
              onClick={(e) => {
                e.stopPropagation();
                window.open(`${finalSrc}`, '_blank');
              }}
            >
              <FeatherIcon icon="eye" size={12} />
              View
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
